import React, { useState, useEffect } from 'react';
import ECharts from 'echarts-for-react';
import { formatUnit } from 'Util';

const FearGreed = ({ data, title }) => {
  
  const [options, setOptions] = useState();

  useEffect(() => {
    if (data) {
      const lineColor = ['#3886EC', '#FF7474', '#000000'];

      const option = {
        animation: false,
        legend: {
          textStyle: { fontSize: 10 },
          itemStyle: { opacity: 0 },
          data: [{
            name: title[0],
            lineStyle: { color: lineColor[0] },
          }, {
            name: title[1],
            lineStyle: { color: lineColor[1] },
          }]
        },
        grid: {
          top: 20,
          right: 10,
          bottom: 10,
          left: 10,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          position: 'bottom',
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitArea: { show: true },
          axisLabel: {
            interval: Math.round(data.x.length/6),
            showMinLabel: true,
            showMaxLabel: true,
            fontSize: 10,
            formatter: (value) => {
              const tmp = value.split('.');
              return tmp[0].substring(2,4) + '.' + tmp[1];
            }
          },
          data: data.x
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              fontSize: 10,
              formatter: (value) => {
                return formatUnit(value);
              }
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          textStyle: {
            fontSize: 10
          },
        },
        series: [
          {
            name: title[0],
            data: data.y1,
            type: 'line',
            symbol: 'none',
            sampling: 'minmax',
            itemStyle: { color: lineColor[0] },
            lineStyle: { color: lineColor[0], width: 2 },
          },
          {
            name: title[1],
            data: data.y2,
            type: 'line',
            symbol: 'none',
            sampling: 'minmax',
            itemStyle: { color: lineColor[1] },
            lineStyle: { color: lineColor[1], width: 2 },
          },
        ],
      }
      setOptions(option);
    }
  }, [data, title]);

	return (
    <div style={{width: '100%', height: '200px'}}>
      {
        options && <ECharts option={options} style={{ width: '100%', height: '100%' }} />
      }
    </div>
  );
}

export default FearGreed;
